import React, { useEffect } from 'react';
import { trackInAnalytics } from '@alfa-bank/newclick-alfa-metrics';

import { Hero } from '../components/hero';
import { Steps } from '../components/steps';

import styles from './index.module.css';

import '../../shared/global.css';

export const App = () => {
    useEffect(() => {
        trackInAnalytics('OPEN_LANDING', undefined);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <Hero className={styles.hero} />
                <Steps />
            </div>
        </div>
    );
};
